import { render } from "./AboutPage.vue?vue&type=template&id=2d09e123&scoped=true"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=2d09e123&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d09e123"]])

export default __exports__